// ─── Finnhub's company-profile words, in Hebrew ──────────────────────────────
//
// Finnhub's profile2 returns its fields in English ("Technology", "US",
// "NASDAQ NMS - GLOBAL MARKET"), and the company panel printed them as they
// came (2026-09-26). These are translations of fixed vocabulary, not data: a
// value that is not listed is shown as Finnhub wrote it, never guessed at.

const EXCHANGE_HE = [
  [/^NASDAQ/i, 'נאסד"ק'],
  [/^NEW YORK STOCK EXCHANGE/i, 'הבורסה של ניו יורק (NYSE)'],
  [/^NYSE ARCA/i, 'NYSE Arca'],
  [/^NYSE AMERICAN|^NYSE MKT/i, 'NYSE American'],
  [/^TEL AVIV/i, 'הבורסה בתל אביב'],
];

const COUNTRY_HE = {
  US: 'ארה"ב', IL: "ישראל", GB: "בריטניה", CA: "קנדה", DE: "גרמניה", FR: "צרפת",
  NL: "הולנד", IE: "אירלנד", CH: "שווייץ", JP: "יפן", CN: "סין", HK: "הונג קונג",
  TW: "טייוואן", KR: "דרום קוריאה", IN: "הודו", AU: "אוסטרליה", BR: "ברזיל",
  DK: "דנמרק", SE: "שוודיה", NO: "נורווגיה", ES: "ספרד", IT: "איטליה", SG: "סינגפור",
  BM: "ברמודה", KY: "איי קיימן", LU: "לוקסמבורג", MX: "מקסיקו", AR: "ארגנטינה",
};

const INDUSTRY_HE = {
  "Technology": "טכנולוגיה",
  "Semiconductors": "מוליכים למחצה",
  "Media": "מדיה",
  "Retail": "קמעונאות",
  "Banking": "בנקאות",
  "Financial Services": "שירותים פיננסיים",
  "Insurance": "ביטוח",
  "Pharmaceuticals": "תרופות",
  "Biotechnology": "ביוטכנולוגיה",
  "Health Care": "בריאות",
  "Life Sciences Tools & Services": "כלים ושירותים למדעי החיים",
  "Automobiles": "רכב",
  "Auto Components": "רכיבי רכב",
  "Energy": "אנרגיה",
  "Oil & Gas": "נפט וגז",
  "Utilities": "תשתיות ושירותים ציבוריים",
  "Telecommunication": "תקשורת",
  "Communications": "תקשורת",
  "Real Estate": 'נדל"ן',
  "Aerospace & Defense": "תעופה וביטחון",
  "Airlines": "תעופה",
  "Beverages": "משקאות",
  "Food Products": "מזון",
  "Tobacco": "טבק",
  "Chemicals": "כימיקלים",
  "Metals & Mining": "מתכות וכרייה",
  "Paper & Forest": "נייר ויער",
  "Machinery": "מכונות",
  "Electrical Equipment": "ציוד חשמלי",
  "Industrial Conglomerates": "קונגלומרטים תעשייתיים",
  "Building": "בנייה",
  "Construction": "בנייה",
  "Hotels, Restaurants & Leisure": "מלונאות, מסעדות ופנאי",
  "Textiles, Apparel & Luxury Goods": "הלבשה ומוצרי יוקרה",
  "Consumer products": "מוצרי צריכה",
  "Logistics & Transportation": "לוגיסטיקה ותחבורה",
  "Road & Rail": "תחבורה יבשתית",
  "Commercial Services & Supplies": "שירותים עסקיים",
  "Professional Services": "שירותים מקצועיים",
  "Trading Companies & Distributors": "סחר והפצה",
  "Distributors": "הפצה",
  "Packaging": "אריזה",
  "Marine": "ספנות",
  "Leisure Products": "מוצרי פנאי",
  "Diversified Consumer Services": "שירותי צרכנות",
};

export const exchangeHe = v => (EXCHANGE_HE.find(([re]) => re.test(v || "")) || [])[1] || v;
export const countryHe  = v => COUNTRY_HE[String(v || "").toUpperCase()] || v;
export const industryHe = v => INDUSTRY_HE[v] || v;
